import Breadcrumbs from '~/components/Breadcrumbs';
import CompanyBanner from '~/components/Companies/CompanyBanner';
import CompanyContactPanel from '~/components/Companies/CompanyContactPanel';
import CompanyIntro from '~/components/Companies/CompanyIntro';
import PartnershipPanel from '~/components/Companies/PartnershipPanel';
import ProviderScopesPanel from '~/components/Companies/ProviderScopesPanel';
import Container from '~/components/ui/Container';
import { currentUrl } from '~/helpers/projectConstant';
import DefaultLayout from '~/layouts/DefaultLayout';
import type { BreadcrumbLink } from '~/types/common/Breadcrumb';
import { ProviderDetails } from '~/types/Provider';

export type ProviderProfileProps = ProviderDetails;

export const ProviderProfile: React.FC<ProviderProfileProps> = ({
  name,
  slug,
  description,
  website,
  email,
  telephone,
  logoUrl,
  scopes,
  partnerText,
  address,
  statistics,
  banner,
}) => {
  const breadcrumbLinks: BreadcrumbLink[] = [
    { name: 'Home', linkTo: '/' },
    { name: 'Aanbieders', linkTo: '/over/aanbieders' },
    { name, linkTo: currentUrl },
  ];

  return (
    <DefaultLayout
      breadcrumbs={<Breadcrumbs links={breadcrumbLinks} variant="inverted" />}
      bgClassName="bg-blue-700"
    >
      <CompanyBanner
        banner={banner}
        companyName={name}
        companyLogo={logoUrl}
        companyType="provider"
      />
      <CompanyIntro
        companyName={name}
        companyDescription={description}
        companyStats={{
          officesCount: statistics.numberOfOffices,
          employeesCount: statistics.numberOfAdvisors,
        }}
      />
      <Container className="pb-16 md:pb-24">
        <PartnershipPanel
          hasPartnership={!!partnerText}
          partnershipDetailsLink={`/over/aanbieder/${slug}/samenwerking`}
        />
        <CompanyContactPanel
          companyName={name}
          address={address}
          websiteAddress={website}
          emailAddress={email}
          phoneNumber={telephone}
        />
        <ProviderScopesPanel
          companyName={name}
          scopes={scopes}
          hasPartnership={!!partnerText}
        />
      </Container>
    </DefaultLayout>
  );
};
